import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";
import CheckboxImage from "../../assets/checkbox.png";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CheckboxContainer = styled.div<{ isCheck: boolean }>`
  display: flex;
  align-items: center;
    background-color: ${({ isCheck }) => (isCheck ? "#edeff9" : "#f7f9fd")};
    border: 1px solid ${({ isCheck }) => (isCheck ? "#4553fb" : "transparent")};
  padding-left: 12px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  appearance: none;
  width: 22px;
  height: 20px;
  border: 2px solid ${({ theme }) => theme.colors.GREY_EXTRA_HEAVY};
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  outline: none;
  margin-right: 8px;

  &:checked {
    border: 1px solid ${({ theme }) => theme.colors.BLUE_HEAVY};
    background-image: url(${CheckboxImage});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
`;
